// extracted by mini-css-extract-plugin
export default {"search":"risks_search__9J09R","fieldRow":"risks_fieldRow__Tgmov","field":"risks_field__gmijE","count":"risks_count__7iwe1","list":"risks_list__QEOL-"};